import PATHS from "@/constants/Paths";
import { mapMutations, mapState } from "vuex";
import { BUYER } from "@/constants/Buyer";
import { SHOWCASE } from "@/constants/Showcase";
import VEHICLES from "@/constants/Vehicles";
import {FAVORITE} from "@/constants/Favorite";

export default {
  computed: {
    ...mapState({
      currentMainMenuSelected: (state) => state.global.currentMainMenuSelected,
    }),
  },
  methods: {
    ...mapMutations("followCarModalModule", ["toggleModal"]),
    ...mapMutations("buyer", [
      "setTitlePage",
      "setTitleSectionPage",
      "setSubTitlePage",
      "setCurrentStatusLote"
    ]),
    ...mapMutations("filterShowcase", [
      "setSelectedCarousel"
    ]),
    navigateTo: function (url, params) {
      this.$router.push(url, params);
    },
    navigatePortalTo: function (url) {

      const fullUrl = `${window.location.origin}/anunciante/${url}`;
      window.open(fullUrl, '_blank');
    },
    navigateToHomePage: function() {
      this.navigateTo(PATHS.Vehicles);
    },
    navigateToDashboardPage: function () {
      this.setSubTitlePage("");
      if (this.currentMainMenuSelected == "vehicles") {
        this.setTitlePage(VEHICLES.TITLE_DASHBOARD);
        this.setTitleSectionPage(VEHICLES.TITLE_SECTION_DEFAULT);
        window.location.href = PATHS.Showcase.Root;
      }
      else if (this.currentMainMenuSelected == "showcase") {
        this.setTitlePage(SHOWCASE.TITLE_DASHBOARD);
        this.setTitleSectionPage(SHOWCASE.TITLE_SECTION_DEFAULT);
        this.setSelectedCarousel(null);
        window.location.href = PATHS.Showcase.Root;
      }
      else if (this.currentMainMenuSelected == "favorites") {
        this.setTitlePage(FAVORITE.TITLE_DASHBOARD);
        this.setTitleSectionPage(FAVORITE.TITLE_SECTION_DEFAULT);
        window.location.href = PATHS.Showcase.Root;
      }
      else {
        this.setTitlePage(BUYER.TITLE_DASHBOARD);
        this.setTitleSectionPage(BUYER.TITLE_SECTION_DEFAULT);
        window.location.href = PATHS.Buyer.Root;
      }
    },
    natigateToInVehicleDetailPage: function (params = {}) {
      this.navigateTo(PATHS.Buyer.VehicleDetail, params);
    },
    natigateToInPackageDetailPage: function (params = {}) {
      this.navigateTo(PATHS.Buyer.LotDetail, params);
    },
    natigateToInProgressPage: function () {
      this.navigateTo(PATHS.Buyer.InProgress);
    },
    natigateToBidInProgressPage: function () {
      this.navigateTo(PATHS.Buyer.BidInProgress);
    },
    natigateToProposalInProgressPage: function () {
      this.navigateTo(PATHS.Buyer.ProposalInProgress);
    },
    natigateToQuotesInProgressPage: function () {
      this.navigateTo(PATHS.Buyer.QuotesInProgress);
    },
    natigateToAutoBidInProgressPage: function () {
      this.navigateTo(PATHS.Buyer.AutoBidInProgress);
    },
    natigateToLotsInProgressPage: function () {
      this.setCurrentStatusLote("progress");
      this.navigateTo(PATHS.Buyer.LotsInProgress);
    },
    natigateToPedingPage: function () {
      this.navigateTo(PATHS.Buyer.Pending);
    },
    natigateToServicePage: function () {
      this.navigateTo(PATHS.Buyer.Service);
    },
    natigateToPaymentPendingPage: function () {
      this.navigateTo(PATHS.Buyer.PaymentPending);
    },
    natigateToReleasePendingPage: function () {
      this.navigateTo(PATHS.Buyer.ReleasePending);
    },
    natigateToProposalPendingPage: function () {
      this.navigateTo(PATHS.Buyer.ProposalPending);
    },
    natigateToBidPendingPage: function () {
      this.navigateTo(PATHS.Buyer.BidPending);
    },
    natigateToClosedPage: function () {
      this.navigateTo(PATHS.Buyer.Closed);
    },
    natigateToAnnouncementCompletedPurchasesClosedPage: function (plate = null) {
      this.$router.push({
        path: PATHS.Buyer.AnnouncementCompletedPurchasesClosed,
        query: { plate: plate },
      });
    },
    natigateToProposalCompletedPurchasesClosedPage: function (plate = null) {
      this.$router.push({
        path: PATHS.Buyer.ProposalCompletedPurchasesClosed,
        query: { plate: plate },
      });
    },
    natigateToQuotesCompletedPurchasesClosedPage: function (plate = null) {
      this.$router.push({
        path: PATHS.Buyer.QuotesCompletedPurchasesClosed,
        query: { plate: plate },
      });
    },
    natigateToAutoBidCompletedPurchasesClosedPage: function (plate = null) {
      this.$router.push({
        path: PATHS.Buyer.AutoBidCompletedPurchasesClosed,
        query: { plate: plate },
      });
    },
    natigateToBuyNowCompletedPurchasesClosedPage: function (defaultPeriodFilter = null, plate = null) {
      this.$router.push({
        path: PATHS.Buyer.BuyNowCompletedPurchasesClosed,
        query: { period: defaultPeriodFilter, plate: plate },
      });
    },
    natigateToOnDemandAssessmentCompletedPurchasesPage: function (plate = null) {
      this.$router.push({
        path: PATHS.Buyer.OnDemandAssessmentPurchasesClosed,
        query: { plate: plate },
      });
    },
    natigateToAutoLotsCompletedPurchasesClosedPage: function () {
      this.setCurrentStatusLote("completed");
      this.navigateTo(PATHS.Buyer.LotsCompletedPurchasesClosed);
    },
    natigateToAnnouncementUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.AnnouncementUnfulfilledPurchasesClosed);
    },
    natigateToQuotesUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.QuotesUnfulfilledPurchasesClosed);
    },
    natigateToAutoBidUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.AutoBidUnfulfilledPurchasesClosed);
    },
    natigateToLotsUnfulfilledPurchasesClosedPage: function () {
      this.setCurrentStatusLote("unfulfilled");
      this.navigateTo(PATHS.Buyer.LotsUnfulfilledPurchasesClosed);
    },
    natigateToCanceledUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.CanceledUnfulfilledPurchasesClosed);
    },
    natigateToOnDemandAssessmentInProgressPage: function () {
      this.navigateTo(PATHS.Buyer.OnDemandAssessmentInProgress);
    },
    natigateToOnDemandAssessmentPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.OnDemandAssessmentPurchasesClosed);
    },
    natigateToOnDemandAssessmentPending: function () {
      this.navigateTo(PATHS.Buyer.ProposOnDemandAssessmentalPending);
    },
    natigateToAssessmentUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.AssessmentUnfulfilledPurchasesClosed);
    },
    natigateToRejectedUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.RejectedUnfulfilledPurchasesClosed);
    },
    natigateToOnDemandAssessmentUnfulfilledPurchasesClosedPage: function () {
      this.navigateTo(PATHS.Buyer.OnDemandAssessmentUnfulfilledPurchasesClosed);
    },
    navigateToCreditLetterPage: function () {
      this.navigateTo(PATHS.Buyer.CreditLetter);
    },
    navigatePortalToDashboard() {
      this.setTitlePage(SHOWCASE.TITLE_DASHBOARD);
      this.setTitleSectionPage(SHOWCASE.TITLE_SECTION_DEFAULT);
      this.navigateTo(PATHS.Showcase.Root);
      this.setSelectedCarousel(null);
      this.toggleModal();

    },
    reloadHomePageNewPortal() {
      window.location.href = '/';
    },
  },
};
